import React, { ComponentType, FC } from 'react';

import { Messaging } from './components/Messaging';
import { UiPortal } from './components/UiPortal';


export const MessagingModule: FC<{ Next: ComponentType }> = ({ Next }) => (
    <>
        <Messaging />
        <UiPortal />
        <Next />
    </>
);
